import { TranslationKeys } from "./en";

export const fr: TranslationKeys = {
  // Loading
  loading: "Chargement du sondage...",
  
  // Thank you page
  thankYou: "Merci!",
  surveySubmitted: "Votre réponse au sondage a déjà été soumise.",
  appreciateParticipation: "Nous apprécions votre participation et vos commentaires.",
  
  // Survey closed page
  surveyClosed: "Ce sondage n'accepte plus de réponses supplémentaires pour le moment. Merci!",
  
  // Error page
  invalidSurveyLink: "Ce n'est pas un lien de sondage valide.",
  surveyLoadError: "Le sondage n'a pas pu être chargé. Veuillez vérifier l'URL et réessayer.",
  
  // No survey data page
  noSurveyAvailable: "Aucun sondage disponible",
  surveyNotFound: "Le sondage que vous recherchez est introuvable ou n'est plus disponible.",
  
  // Invalid URL page
  invalidSurveyUrl: "URL de sondage invalide",
  invalidUrlMessage: "Le lien du sondage n'est pas valide. Veuillez vérifier l'URL et réessayer.",
  
  // Survey renderer errors
  submitFailed: "Échec de la soumission de la réponse au sondage. Veuillez réessayer.",
  
  // PIN Landing Page
  pinWelcome: "Bienvenue! Veuillez entrer votre NIP pour commencer.",
  pinInstructions: "Vous devriez avoir reçu un NIP de votre organisation. Entrez-le ci-dessous pour accéder au sondage. Les NIP ne sont pas sensibles à la casse.",
  enterYourPin: "Entrez votre NIP",
  pinPlaceholder: "par exemple, ABC123 ou 987654",
  pinError: "NIP invalide. Veuillez réessayer.",
  submit: "Soumettre",
  submitting: "Soumission en cours...",
  pinNeedHelp: "Besoin d'aide? Contactez votre administrateur RH pour assistance.",
  poweredByTalentMap: "Propulsé par TalentMap",
};

